import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { convertJsonToFormData, mapFormData } from 'helpers/formData';

export interface ClientCaseAddendaPostOptions {
  file: File;
  name: string;
  signatureRequired: boolean;
  docusignSignatureRequired: boolean;
  shouldSendSignatureReminder?: boolean;
  autoEmailEnabled?: boolean;
  noteForClient?: string;
  phone?: string;
  postCode?: string;
  recipientIdentityVerificationType?: string;
  recipientIdentityVerificationName?: string;
}

export function clientCaseAddendaApi(path: string) {
  return {
    path,
    POST: (params: ClientCaseAddendaPostOptions) =>
      api.post<JsonApiResponseSingle>(
        path,
        convertJsonToFormData({
          data: {
            attributes: mapFormData(params),
          },
        })
      ),
  };
}
